import { CartItemInput, TargetCartItem } from 'contexts/type/cart-type';
import { isValueEmpty } from 'contexts/cart/utils/index';

// these fields does not define identity of the product
const IGNORE_FIELDS = ['quantity', 'points', 'redeemItem', 'petType'];

/**
 * Builds a string to determine identity of the item.
 * This is needed to differ items with same variantId but different subscriptions, bundles props on them.
 */
export const buildFingerPrint = (cartItem: CartItemInput | TargetCartItem): string => {
  const tokens: string[] = [];

  for (const [key, value] of Object.entries(cartItem)) {
    if (key === 'variantId' && isValueEmpty(value)) {
      // it should not happen, the error should be thrown
      throw new Error('variantId cannot be empty');
    }
    if (IGNORE_FIELDS.includes(key) || isValueEmpty(value)) continue;

    if (key === 'bundleRefs') {
      if (!(Array.isArray(value) && value.length > 0)) continue;
      const bundleToken = value
        .map((b) => b.bundleId)
        .sort()
        .join('_');

      tokens.push(bundleToken);

      continue;
    }

    tokens.push(String(value));
  }

  return tokens.sort().join(tokens.length > 1 ? '_' : '');
};
